import { useSelector } from 'react-redux';

import {
  resolveUserRole,
  resolveUserName,
  hasManagerUploadFlow,
} from '../utils/identity';

// The two reads that used to be spelled out at ~30 call sites, each one lifting
// the role straight out of the persisted `signIn` slice's idToken payload.
//
// Kept as hooks over a bare selector so the fallback order lives in exactly one
// place: the failure these exist for was thirty components independently
// depending on a slice nothing refreshes, and thirty copies of a fallback would
// drift back into the same shape.
//
// Both resolvers return a primitive, so useSelector's default reference
// equality is the right check and no memoisation is needed.

export const useUserRole = () => useSelector(resolveUserRole);

export const useUserName = () => useSelector(resolveUserName);

// Whether the current role is on the manager document flow — the Manager role
// by name, a custom role by its managerUploadFlow permission. Boolean, so the
// default reference equality is again the right check.
export const useManagerUploadFlow = () => useSelector(hasManagerUploadFlow);
